// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c996f9ad75e3455df9ed96e2fb5c5e8e36ad0f77/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};